// api/configApi.ts
import { SecurityOption, OptionPricing } from "../types/productTypes";
import { baseApi } from "./BaseApi";

const productsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getProducts: builder.query<SecurityOption[], void>({
      query: () => `/products`,
    }),
    getProduct: builder.query<SecurityOption, number>({
      query: (productId) => `/products/${productId}`,
    }),
  }),
});

export const { useGetProductsQuery, useGetProductQuery } = productsApi;

export default productsApi;
